import { createAsyncThunk } from "@reduxjs/toolkit";
//export const BASE_URL = 'http://localhost:3002'
     export const BASE_URL = 'https://api.menubook.ru';

  export const getIngredients = createAsyncThunk(
    'ingredients/getIngredients',
    async (_, {rejectWithValue}) => {
      try { 
            const response = await fetch(`${BASE_URL}/ingredients`, {
              method: 'GET',
              headers: {
               'Content-Type': 'application/json',
              },
            })
            if(!response.ok) {
              throw new Error('Server Error!')
            }
            const data = await response.json();
            return data;
          } catch (error) {
              return rejectWithValue(error.message)
          }
    }
  )
//Изменение лайков на рецепте
export const changeLikeRecipe = createAsyncThunk(
  'recipe/changeLike',
  async (arr, {rejectWithValue}) => {
    try {
      const response = await fetch(`${BASE_URL}/recipe/${arr.id}/likes`, {
        method: arr.isLiked ? 'PUT' : 'DELETE',
        headers: {
         'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message)
    }
})

//Изменение лайков на рецепте
export const changeDisLikeRecipe = createAsyncThunk(
  'recipe/changeDisLike',
  async (arr, {rejectWithValue}) => {
    try {
      const response = await fetch(`${BASE_URL}/recipe/${arr.id}/dislikes`, {
        method: arr.isDisLiked ? 'PUT' : 'DELETE',
        headers: {
         'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message)
    }
})

export const postComments = createAsyncThunk(
  'recipe/addcomments',
  async (arr, {rejectWithValue}) => {  
    try {
      const response = await fetch(`${BASE_URL}/recipe/${arr._id}`, {
        method: 'POST',
        headers: {
         'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          comments: arr.comments
        })
      })
      const data = await response.json();
      return data;
    } catch (error) {
        return rejectWithValue(error.message)
    }
})

    //Получение рецептов c лайками пользователя
    export const getUserBonus = createAsyncThunk(
      'bonus/getbonus',
      async (_, {rejectWithValue}) => {
        try { 
            const response = await fetch(`${BASE_URL}/payment/bonus`, {
              method: 'GET',
              headers: {
               'Content-Type': 'application/json',
              },
              credentials: 'include',
            })
            if(!response.ok) {
              throw new Error('Server Error!')
            }
            const data = await response.json();
            return data;
          } catch (error) {
            return rejectWithValue(error.message)
        }
    })

    export const getUserSubs = createAsyncThunk(
      'bonus/getbonus',
      async (arr, {rejectWithValue}) => {
        try { 
            const response = await fetch(`${BASE_URL}/payment/historysubs/${arr.userId}`, {
              method: 'GET',
              headers: {
               'Content-Type': 'application/json',
              },
              credentials: 'include',
            })
            if(!response.ok) {
              throw new Error('Server Error!')
            }
            const data = await response.json();
            return data;
          } catch (error) {
            return rejectWithValue(error.message)
        }
    })

    export const changeSubStatus = createAsyncThunk(
      'subs/changestatus',
      async (arr, {rejectWithValue}) => {
        try { 
            const response = await fetch(`${BASE_URL}/payment/subs/statuschange `, {
              method: 'PATCH',
              headers: {
               'Content-Type': 'application/json',
              },
              credentials: 'include',
              body: JSON.stringify({
                subsId: arr.subsId,
                userId: arr.userId,
              }),
            })
            if(!response.ok) {
              throw new Error('Server Error!')
            }
            const data = await response.json();
            return data;
          } catch (error) {
            return rejectWithValue(error.message)
        }
    })


export const getUserTransaction = createAsyncThunk(
  'bonus/gettransaction',
  async (_, {rejectWithValue}) => {
    try { 
        const response = await fetch(`${BASE_URL}/payment/transaction`, {
          method: 'GET',
          headers: {
           'Content-Type': 'application/json',
          },
          credentials: 'include',
        })
        if(!response.ok) {
          throw new Error('Server Error!')
        }
        const data = await response.json();
        return data;
      } catch (error) {
        return rejectWithValue(error.message)
    }
})

export const deleteUserBonus = createAsyncThunk(
  'bonus/deletebonus',
  async (arr, {rejectWithValue}) => {
    try { 
        const response = await fetch(`${BASE_URL}/payment/bonus/delete`, {
          method: 'PATCH',
          headers: {
           'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            transactionId: arr.transactionId,
            userId: arr.userId,
          }),
          credentials: 'include',
        })
        if(!response.ok) {
          throw new Error('Server Error!')
        }
        const data = await response.json();
        return data;
      } catch (error) {
        return rejectWithValue(error.message)
    }
})

export const editUserBonus = createAsyncThunk(
  'bonus/editbonus',
  async (arr, {rejectWithValue}) => {
    try { 
        const response = await fetch(`${BASE_URL}/payment/bonus/edit`, {
          method: 'PATCH',
          headers: {
           'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            amount: arr.amount,
            userId: arr.id,
          }),
          credentials: 'include',
        })
        if(!response.ok) {
          throw new Error('Server Error!')
        }
        const data = await response.json();
        return data;
      } catch (error) {
        return rejectWithValue(error.message)
    }
})

export const updateUserParametrs = createAsyncThunk(
  'user/userParametrs',
  async (settings, {rejectWithValue}) => {  
    try {
      const response = await fetch(`${BASE_URL}/users/me/parameters`, {
        method: 'PATCH',
        headers: {
         'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          gender: settings.gender, 
          age: settings.age,
          height: settings.height,
          weight: settings.weight,
          activity: settings.activity, 
          calories: settings.calories,
          protein: settings.protein,
          fat: settings.fat,
          carb: settings.carb, 
          bmi: settings.bmi
        })
      })
      if(!response.ok) {
        throw new Error('Server Error!')
      }
      const data = await response.json();
      return data;
    } catch (error) {
        return rejectWithValue(error.message)
    }
})

export const editAccount = createAsyncThunk(
  'user/editAccount',
  async (arr, {rejectWithValue}) => {   
    try {
      const response = await fetch(`${BASE_URL}/users/me`, {
        method: 'PATCH',
        headers: {
         'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          email: arr.email, 
          name: arr.surname, 
          phone: arr.phone, 
          login: arr.login, 
          acces: arr.acces, 
          password: arr.password ? arr.password : '', 
          newPassword: arr.newPassword ? arr.newPassword : '', 
        })
      })
      const data = await response.json();
      if (!response.ok) {
        // Если сервер вернул ошибку с сообщением в data
        return rejectWithValue(data.message || 'Произошла ошибка');
      }

      return data; 
    } catch (error) {
      return rejectWithValue(error.message || 'Ошибка соединения с сервером');
    }
})


export const editPhoto = createAsyncThunk(
  'user/editPhoto',
  async (photo, {rejectWithValue}) => {  
    try {
      const response = await fetch(`${BASE_URL}/users/me/photo`, {
        method: 'PATCH',
        headers: {
         'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify( {photo})
      })
      if(!response.ok) {
        throw new Error('Server Error!')
      }
      const data = await response.json();
      return data;
    } catch (error) {
        return rejectWithValue(error.message)
    }
})

  //Получение рецептов из базы c настройками
  export const getSort = createAsyncThunk(
    'recipe/sort',
    async (_, {rejectWithValue}) => {
      try { 
          const response = await fetch(`${BASE_URL}/recipe/sort`, {
            method: 'GET',
            headers: {
             'Content-Type': 'application/json',
            },
            credentials: 'include',
          })
          if(!response.ok) {
            throw new Error('Server Error!')
          }
          const data = await response.json();
          return data;
        } catch (error) {
          return rejectWithValue(error.message)
      }
  })

export const postPlanManual = createAsyncThunk(
  'menu/postmanual',
  async (plan, {rejectWithValue}) => { 
    try { 
          const response = await fetch(`${BASE_URL}/plan/manual`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({  
              dates: plan.date,
              mealType: plan.mealType, 
              recipeId: plan.recipeId,
            })
          })
          if(!response.ok) {
            throw new Error('Server Error!')
          }
          const data = await response.json();
          return data;
        } catch (error) {
            return rejectWithValue(error.message)
        }
  }
)

  export const getIngPage = createAsyncThunk(
    'ingredients/page',
    async (arr, {rejectWithValue}) => {  
      try {
        const response = await fetch(`${BASE_URL}/ingredients/search?page=${arr.currentPage}&limit=${arr.limit}&title=${arr.title}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },  
        });
        if(!response.ok) {
        throw new Error('Server Error!')
        }
        const data = await response.json();
        const count = response.headers.get('Total-Card')
        return ({data, count});
      } catch (error) {
        return rejectWithValue(error.message)
      }
  })
 

  export const getUpdateFieldIngredients = createAsyncThunk(
    'ingredients/getIngredientss',
    async (_, {rejectWithValue}) => {
      try { 
            const response = await fetch(`${BASE_URL}/ingredients/field`, {
              method: 'GET',
              headers: {
               'Content-Type': 'application/json',
              },
            })
            if(!response.ok) {
              throw new Error('Server Error!')
            }
            const data = await response.json();
            return data;
          } catch (error) {
              return rejectWithValue(error.message)
          }
    }
  )

  // Обновление настроек пользователя
  export const updateUser = createAsyncThunk(
    'user/updateUser',
    async (settings, {rejectWithValue}) => {  
      try {
        const response = await fetch(`${BASE_URL}/users/update/${settings.userId}`, {
          method: 'PATCH',
          headers: {
           'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({settings: settings})
        })
        if(!response.ok) {
          throw new Error('Server Error!')
        }
        const data = await response.json();
        return data;
      } catch (error) {
          return rejectWithValue(error.message)
      }
  })

  export const editUserAcces = createAsyncThunk(
    'user/accesUser',
    async ({supervisor, bonus, rates, dateAcces, finance, settings, id}, {rejectWithValue}) => {  
      try {
        const response = await fetch(`${BASE_URL}/users/me/admin/update/${id}`, {
          method: 'PATCH',
          headers: {
           'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({supervisor, bonus, rates, dateAcces, finance, settings
          }) 
        })
        if(!response.ok) {
          throw new Error('Server Error!')
        }
        const data = await response.json();
        return data;
      } catch (error) {
          return rejectWithValue(error.message)
      }
  })

  
  export const postIngredients = createAsyncThunk(
    'ingredients/postIngredients',
    async (arr, {rejectWithValue}) => {
      try { 
            const response = await fetch(`${BASE_URL}/ingredients`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              credentials: 'include',
              body: JSON.stringify(arr)
            })
            if(!response.ok) {
              const error = await response.json();
              throw new Error(error.statusCode)
            }
            const data = await response.json();
            return data;
          } catch (error) {
              return rejectWithValue(error.message)
          }
    }
  )

  export const addNewIngredients = createAsyncThunk(
    'ingredients/postIngredients',
    async (arr, {rejectWithValue}) => {
      try { 
            const response = await fetch(`${BASE_URL}/ingredients/news`, {
              method: 'PATCH',
              headers: {
                'Content-Type': 'application/json',
              },
              credentials: 'include',
              body: JSON.stringify({ arr: arr})
            })
            if(!response.ok) {
              const error = await response.json();
              throw new Error(error.statusCode)
            }
            const data = await response.json();
            return data;
          } catch (error) {
              return rejectWithValue(error.message)
          }
    }
  )

  //получение данных создателя рецепта(для отображения в источнике)
  export const getUserID = createAsyncThunk(
    'user/getUserID',
    async (text, {rejectWithValue}) => {  
      try {
        const response = await fetch(`${BASE_URL}/users/find`, {
          method: 'POST',
          headers: {
           'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({text: text}),
        })
        if(!response.ok) { 
          throw new Error(response.status)
        }
        const data = await response.json(); 
        return data;
      } catch (error) {
        if (!error.response) {
          throw error
        } 
        return rejectWithValue(error.response.data)
      }
  })

  export const getUsersPage = createAsyncThunk(
    'user/page',
    async (arr, {rejectWithValue}) => {  
      try {
        const response = await fetch(`${BASE_URL}/users/search?page=${arr.currentPage}&limit=${arr.limit}&subs=${arr.subs}&sortBy=${arr.sort}&sortOrder=${arr.sortOrder}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }, 
        credentials: 'include',
        });
        if(!response.ok) {
        throw new Error('Server Error!')
        }
        const data = await response.json();
        const count = response.headers.get('Total-Card')
        return ({data, count});
      } catch (error) {
        return rejectWithValue(error.message)
      }
  })

  //Продление подписки пользователя
  export const extensionSubs = createAsyncThunk(
    'payment/extensionSubs',
    async (arr, {rejectWithValue}) => {
      try {
        const response = await fetch(`${BASE_URL}/payment/subs/extens`, {
          method: 'PATCH',
          headers: {
           'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({
            isActive: arr.isActive,
            subsId: arr.newSubs,
            priceSale: arr.priceSale,
            user: arr.userId,
            period: arr.period,
            promocode: arr.promocode,
          })
        })
        if(!response.ok) { 
          throw new Error(response.status)
        }
        const data = await response.json();
        if (data.paymentRequired) {
          console.log(data)
          localStorage.setItem('paymentAttempt', JSON.stringify({ 
            paymentId: data.paymentId,
            endDate: data.endDate,
            userId: data.userId,
            subsId: data.subsId,
            timestamp: new Date().toISOString()
          }));
        // Перенаправляем пользователя на страницу оплаты
        window.location.href = data.confirmationUrl;
        } else {
         // Подписка активирована за бонусы/бесплатно
        return data
        }
      } catch (error) {
        if (!error.response) {
          throw error
        } 
        return rejectWithValue(error.response.data)
      } 
    }
  )
  
  //Смена подписки пользователя
  export const changeSubscription = createAsyncThunk(
    'payment/changeSubs',
    async (arr, {rejectWithValue}) => {
      try {
        const response = await fetch(`${BASE_URL}/payment/subs/change`, {
          method: 'PATCH',
          headers: {
           'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({
            isActive: arr.isActive,
            bonus: arr.bonus,
            subsId: arr.newSubs,
            priceSale: arr.priceSale,
            user: arr.userId,
            period: arr.period,
            promocode: arr.promocode,
          })
        })
        if(!response.ok) { 
          throw new Error(response.status)
        }
        const data = await response.json();
        if (data.paymentRequired) {
          console.log(data)
          localStorage.setItem('paymentAttempt', JSON.stringify({ 
            paymentId: data.paymentId,
            userId: data.userId,
            subsId: data.subsId,
            endDate: data.endDate,
            timestamp: new Date().toISOString()
          }));
        // Перенаправляем пользователя на страницу оплаты
         window.location.href = data.confirmationUrl;
        } else {
         // Подписка активирована за бонусы/бесплатно
          alert(data.message);
          return data
        }
      } catch (error) {
        if (!error.response) {
          throw error
        } 
        return rejectWithValue(error.response.data)
      } 
    }
  )

  export const changeSubsVisor = createAsyncThunk(
    'payment/changeSubsVisor',
    async (arr, {rejectWithValue}) => {
      try {
        const response = await fetch(`${BASE_URL}/payment/subs/changevisor`, {
          method: 'PATCH',
          headers: {
           'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({ 
            subsId: arr.newSubs, 
            date: arr.date, 
            userId: arr.userId
          })
        })
        if(!response.ok) { 
          throw new Error(response.status)
        }
        const data = await response.json();
        
          return data
        
      } catch (error) {
        if (!error.response) {
          throw error
        } 
        return rejectWithValue(error.response.data)
      } 
    }
  )
 
  export const verifyPayment = createAsyncThunk(
    'payment/verify',
    async (paymentId, {rejectWithValue}) => {
      try {
        const response = await fetch(`${BASE_URL}/payment/verify/${paymentId}`, {
          method: 'GET',
          headers: {
           'Content-Type': 'application/json',
          },
          credentials: 'include', 
        })
        
        if (!response.ok) {
          throw new Error('Ошибка при проверке платежа');
        }
        const data = await response.json(); 
        console.log(data)
        return data
      } catch (error) {
        if (!error.response) {
          throw error
        } 
        return rejectWithValue(error.response.data)
      } 
    }
  )
 
  export const getPayment = createAsyncThunk(
    'payment/get',
    async (pay, {rejectWithValue}) => {
      console.log(pay)
      try {
        const response = await fetch(`${BASE_URL}/payment`, {
          method: 'GET',
          headers: {
           'Content-Type': 'application/json',
          },
          credentials: 'include', 
          
        })
        
        if (!response.ok) {
          throw new Error('Ошибка при проверке платежа');
        }
        const data = await response.json(); 
        return data
      } catch (error) {
        if (!error.response) {
          throw error
        } 
        return rejectWithValue(error.response.data)
      } 
    }
  )


  export const getNote = createAsyncThunk(
    'note/get',
    async (pay, {rejectWithValue}) => {
      console.log(pay)
      try {
        const response = await fetch(`${BASE_URL}/note`, {
          method: 'GET',
          headers: {
           'Content-Type': 'application/json',
          },
          credentials: 'include', 
          
        })
        
        if (!response.ok) {
          throw new Error('Ошибка при проверке платежа');
        }
        const data = await response.json(); 
        return data
      } catch (error) {
        if (!error.response) {
          throw error
        } 
        return rejectWithValue(error.response.data)
      } 
    }
  )


   export const userActivities = createAsyncThunk(
    'user/activity',
    async (userId, {rejectWithValue}) => { 
      try {
        const response = await fetch(`${BASE_URL}/users/monitoring/${userId}`, {
          method: 'GET',
          headers: {
           'Content-Type': 'application/json',
          },
          credentials: 'include', 
          
        })
        
        if (!response.ok) {
          throw new Error('Ошибка при проверке платежа');
        }
        const data = await response.json(); 
        return data
      } catch (error) {
        if (!error.response) {
          throw error
        } 
        return rejectWithValue(error.response.data)
      } 
    }
  )

  export const editVisor = createAsyncThunk(
    'user/editVisor',
    async (arr, {rejectWithValue}) => {  
      try {
        const response = await fetch(`${BASE_URL}/users/me/visor/${arr.id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        }, 
        credentials: 'include',
        body: JSON.stringify({supervisor: arr.supervisor,current: arr.current})
        });
        if(!response.ok) {
        throw new Error('Server Error!')
        }
        const data = await response.json();
        return data;
      } catch (error) {
        return rejectWithValue(error.message)
      }
  }) 
 
 // ПРиянтие рецепта
  export const acceptRecipeUser = createAsyncThunk(
    'payment/bonus',
    async (recipeId, {rejectWithValue}) => {  
      try {
        const response = await fetch(`${BASE_URL}/payment/bonus`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        }, 
        body: JSON.stringify({
          recipeId
        }),
        credentials: 'include',
        });

        if(!response.ok) { 
          console.log(response)
          throw new Error(response.status) 
        }
        const data = await response.json();
        return data;
      } catch (error) {
        if (!error.response) {
          throw error
        } 
         console.log(error)
        return rejectWithValue(error.response.data) 
      }
  })

  export const fetchFilter = createAsyncThunk(
    'resipes/page',
    async (arr, {rejectWithValue}) => {  
      try {
        const response = await fetch(`${BASE_URL}/recipe/search?page=${arr.currentPage}&limit=${arr.limit}&filter=${arr.filter}&user=${arr.user}&sorter=${arr.sorter}&moderator=${arr.moderator}&title=${arr.searchWords}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }, 
        credentials: 'include',
        });
        if(!response.ok) {
        throw new Error('Server Error!')
        }
        const data = await response.json();
        const count = response.headers.get('Total-Card')
        return ({data, count});
      } catch (error) {
        return rejectWithValue(error.message)
      }
  })
  export const deleteIngredients = createAsyncThunk(
    'ingredients/deleteIngredients',
    async (id, {rejectWithValue}) => {
      try {
        const response = await fetch(`${BASE_URL}/ingredients/${id}`, {
          method: 'DELETE',
          headers: {
           'Content-Type': 'application/json',
          },
          credentials: 'include',
        })
        const data = await response.json();
        return data;
      } catch (error) {
          return rejectWithValue(error.message)
      }
  })

  export const deleteUsers = createAsyncThunk(
    'ingredients/deleteUsers',
    async (arr, {rejectWithValue}) => {
      try {
        const response = await fetch(`${BASE_URL}/users/me/admin/${arr.id}`, {
          method: 'DELETE',
          headers: {
           'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({current: arr.current})
        })
        const data = await response.json();
        return data;
      } catch (error) {
          return rejectWithValue(error.message)
      }
  })

  export const editIngredients = createAsyncThunk(
    'ingredients/editIngredients',
    async (arr, {rejectWithValue}) => {
      try {
        const response = await fetch(`${BASE_URL}/ingredients/${arr.id}`, {
          method: 'PATCH',
          headers: {
           'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({
            name: arr.values.name,
            nameRu: arr.values.name,
            trait: arr.values.trait,
            nameEn: arr.values.nameEn,
            fields: arr.fields,
            brands: arr.choiceIngredient,
            mainMeasure: arr.values.mainMeasure,
            cooking: arr.values.cooking,
            minerals: arr.minerals, 
            frying: arr.values.frying,
            season: arr.values.season,
            purified: arr.values.purified,
            packing: [],
            calories: {
              protein: arr.values.protein,
              fats: arr.values.fats,
              carb: arr.values.carb,
              calories: arr.values.calories,
              digest: arr.values.digest,
            },
            measure: arr.measures,
            vitamins: arr.vitamins, 
            accusativeCase: '',
            genitiveCase: '',
            instrumentalCase: '',
            category: arr.values.category,
            desc: `${arr.values.desc ? arr.values.desc: ''}`,
            image: [],
            choisMeasure: arr.values.mainMeasure,
            weight: 0,
            price: {
              rate: arr.values.price,
              weightprice: arr.values.weightprice,
              measureprice: arr.values.mainMeasure,
            },
          })
        })
        const data = await response.json();
        return data;
      } catch (error) {
          return rejectWithValue(error.message)
      }
  })

  export const EditVitIngredients = createAsyncThunk(
    'ingredients/editVitIngredients',
    async (arr, {rejectWithValue}) => {
      console.log(arr)
      try {
        const response = await fetch(`${BASE_URL}/ingredients/vitamins`, {
          method: 'PATCH',
          headers: {
           'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({ arr: arr})
        })
        const data = await response.json();
        return data;
      } catch (error) {
          return rejectWithValue(error.message)
      }
  })

  //Добавление рецепта в базу
  export const postRecipe = createAsyncThunk(
    'recipe/addrecipe',
    async (arr, {rejectWithValue}) => {  
      try {
        const response = await fetch(`${BASE_URL}/recipe`, {
          method: 'POST',
          headers: {
           'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify(arr)
        })
        const data = await response.json();
        return data;
      } catch (error) {
          return rejectWithValue(error.message)
      }
  })

  export const getRecipe = createAsyncThunk(
    'recipe/getrecipe',
    async (_, {rejectWithValue}) => {
     
      try {
        const response = await fetch(`${BASE_URL}/recipes`, {
          method: 'GET',
          headers: {
           'Content-Type': 'application/json',
          },
          credentials: 'include',
        })
        const data = await response.json();
        return data;
      } catch (error) {
          return rejectWithValue(error.message)
      }
  })

  export const getRecipeId = createAsyncThunk(
    'recipe/getrecipeId',
    async (id, {rejectWithValue}) => {
      try {
        const response = await fetch(`${BASE_URL}/recipe/${id}`, {
          method: 'GET',
          headers: {
           'Content-Type': 'application/json',
          },
          credentials: 'include',
        })
        const data = await response.json();
        return data;
      } catch (error) {
          return rejectWithValue(error.message)
      }
  })

  export const changesRecipeStructure = createAsyncThunk(
    'recipe/structure',
    async (_, {rejectWithValue}) => {
     
      try {
        const response = await fetch(`${BASE_URL}/recipe/updatestructure`, {
          method: 'PATCH',
          headers: {
           'Content-Type': 'application/json',
          },
          credentials: 'include', 
        })
        const data = await response.json();
        return data;
      } catch (error) {
          return rejectWithValue(error.message)
      }
  })


  export const changesUsersStructure = createAsyncThunk(
    'users/structure',
    async (_, {rejectWithValue}) => {
     
      try {
        const response = await fetch(`${BASE_URL}/users/updatestructure`, {
          method: 'PATCH',
          headers: {
           'Content-Type': 'application/json',
          },
          credentials: 'include', 
        })
        const data = await response.json();
        return data;
      } catch (error) {
          return rejectWithValue(error.message)
      }
  })

  export const changesUserRates = createAsyncThunk(
    'user/changerates',
    async (_, {rejectWithValue}) => {
     
      try {
        const response = await fetch(`${BASE_URL}/users/changerates`, {
          method: 'PATCH',
          headers: {
           'Content-Type': 'application/json',
          },
          credentials: 'include', 
        })
        const data = await response.json();
        return data;
      } catch (error) {
          return rejectWithValue(error.message)
      }
  })

  export const getUserActivity = createAsyncThunk(
    'user/getUserActivity',
    async (arr, {rejectWithValue}) => {
      try {
        const response = await fetch(`${BASE_URL}/admin/userActivity/search?page=${arr.currentPage}&limit=${arr.limit}&sort=${arr.sort}&userId=${arr.userId}`, {
          method: 'GET',
          headers: {
           'Content-Type': 'application/json',
          },
          credentials: 'include',
        })
        const data = await response.json();
        return data;
      } catch (error) {
          return rejectWithValue(error.message)
      }
  })

  export const getUser = createAsyncThunk(
    'user/getUser',
    async (_, {rejectWithValue}) => {
      try {
        const response = await fetch(`${BASE_URL}/users/me`, {
          method: 'GET',
          headers: {
           'Content-Type': 'application/json',
          },
          credentials: 'include',

        })
        const data = await response.json();
        return data;
      } catch (error) {
          return rejectWithValue(error.message)
      }
  })

  export const deleteRecipe = createAsyncThunk(
    'recipe/deleteRecipe',
    async (id, {rejectWithValue}) => {
      try {
        const response = await fetch(`${BASE_URL}/recipe/${id}`, {
          method: 'DELETE',
          headers: {
           'Content-Type': 'application/json',
          },
          credentials: 'include',
        })
        const data = await response.json();
        return data;
      } catch (error) {
          return rejectWithValue(error.message)
      }
  })

  export const deleteVitamins = createAsyncThunk(
    'ingredients/deleteVitamins',
    async (_, {rejectWithValue}) => {
      try {
        const response = await fetch(`${BASE_URL}/ingredients/vitamins`, {
          method: 'DELETE',
          headers: {
           'Content-Type': 'application/json',
          },
          credentials: 'include',
        })
        const data = await response.json();
        return data;
      } catch (error) {
          return rejectWithValue(error.message)
      }
  })


  export const editRecipe = createAsyncThunk(
    'recipe/editRecipe',
    async (arr, {rejectWithValue}) => {
      try {
        const response = await fetch(`${BASE_URL}/recipe/${arr.id}`, {
          method: 'PATCH',
          headers: {
           'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify(arr.data)
        })
        if(!response.ok) { 
          throw new Error(response.status)
        }
        const data = await response.json();
        return data;
      } catch (error) {
        if (!error.response) {
          throw error
        } 
        return rejectWithValue(error.response.data)
      } 
    }
  )

  export const editRecipeMeta = createAsyncThunk(
    'recipe/editRecipeMeta',
    async (arr, {rejectWithValue}) => {
      try {
        const response = await fetch(`${BASE_URL}/recipe/${arr.id}`, {
          method: 'PATCH',
          headers: {
           'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify(arr)
        })
        const data = await response.json();
        return data;
      } catch (error) {
          return rejectWithValue(error.message)
      }
  })
 


  // Добавление данных в библиотеку
  export const postLibrary = createAsyncThunk(
    'lib/postLibrary',
    async (arr, {rejectWithValue}) => { 
      console.log(arr)
      try { 
            const response = await fetch(`${BASE_URL}/lib/${arr.name}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              credentials: 'include',
              body: JSON.stringify({data: arr.values})
              
            })
            if(!response.ok) {
              const error = await response.json();
              throw new Error(error.statusCode)
            }
            const data = await response.json();
            return data;
          } catch (error) {
            console.log(error)
              return rejectWithValue(error.message)
          }
    }
  )

// Получение данных из библиотеки
  export const getLibrary = createAsyncThunk(
    'lib/getLibrary',
    async (_, {rejectWithValue}) => {
      try { 
            const response = await fetch(`${BASE_URL}/lib`, {
              method: 'GET',
              headers: {
               'Content-Type': 'application/json',
              },
              credentials: 'include',
            })
            if(!response.ok) {
              throw new Error('Server Error!')
            }
            const data = await response.json();
            return data;
          } catch (error) {
              return rejectWithValue(error.message)
          }
    }
  )

  //Первое заполнение библиотеки
  export const postLib = createAsyncThunk(
    'lib/postLib',
    async (arr, {rejectWithValue}) => { 
      try { 
            const response = await fetch(`${BASE_URL}/lib`, {
              method: 'PATCH',
              headers: {
                'Content-Type': 'application/json',
              },
              credentials: 'include',
              body: JSON.stringify({
                 vitamins: arr.lib.vitamins,
                 brands: arr.lib.brands,
                 typeFoods: arr.lib.typeFoods,
                 measure: arr.lib.measure,
                 catIn: arr.lib.catIn,
                 dish: arr.lib.dish,
                 except: arr.lib.except,
                 rates: arr.rates,
                 promocode: arr.promocode,
              })
            })
            if(!response.ok) {
              const error = await response.json();
              throw new Error(error.statusCode)
            } 
            const data = await response.json();
            return data;
          } catch (error) {
            console.log(error)
              return rejectWithValue(error.message)
          }
    }
  )

  //Удаление данных из библиотеки
  export const deleteLibrary = createAsyncThunk(
    'lib/deleteRecipe',
    async (arr, {rejectWithValue}) => {
      try {
        const response = await fetch(`${BASE_URL}/library/${arr.id}`, {
          method: 'DELETE',
          headers: {
           'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({name: arr.name})
        })
        const data = await response.json();
        return data;
      } catch (error) {
          return rejectWithValue(error.message)
      }
  })

  export const updateLibrary = createAsyncThunk(
    'lib/updateLibrary',
    async (arr, {rejectWithValue}) => {
      console.log(arr)
      try { 
        const response = await fetch(`${BASE_URL}/lib/${arr.id}`, {
          method: 'PATCH',
          headers: {
           'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({data: arr.values, name: arr.name})
        })
        const data = await response.json();
        return data;
      } catch (error) {
          return rejectWithValue(error.message)
      }
  })

  export const addPromocode = createAsyncThunk(
  'lib/addPromocode',
  async (promoData, { rejectWithValue }) => { 
    try {
      const response = await fetch(`${BASE_URL}/lib/promocode`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(promoData)
      });
      
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletePromocode = createAsyncThunk(
  'lib/deletePromocode',
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${BASE_URL}/lib/c/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });
      
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message);
      }
      
      return { id };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

   //Получение списка меню из базы
   export const getPlan = createAsyncThunk(
    'plan/getplan',
    async (_, {rejectWithValue}) => {
     
      try {
        const response = await fetch(`${BASE_URL}/plan`, {
          method: 'GET',
          headers: {
           'Content-Type': 'application/json',
          },
          credentials: 'include',
        })
        if(!response.ok) {
          throw new Error('Server Error!')
        }
        const data = await response.json();
        return data;
      } catch (error) {
          return rejectWithValue(error.message)
      }
  })